import { render, staticRenderFns } from "./HighlightNews.vue?vue&type=template&id=3ea28637&scoped=true&"
import script from "./HighlightNews.vue?vue&type=script&lang=js&"
export * from "./HighlightNews.vue?vue&type=script&lang=js&"
import style0 from "./HighlightNews.vue?vue&type=style&index=0&id=3ea28637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea28637",
  null
  
)

export default component.exports